import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getOfficeStatus = async () => { 
   return await axios.get(
    `${api_base_url}/Configuration/OfficeStatus`
  );

};
//Insert New OfficeStatus
export const addOfficeStatus = async (newOfficeStatus) => {
  const { data } = await axios.post(
    `${api_base_url}/Configuration/OfficeStatus`,
    { ...newOfficeStatus }
  );
  
  return data;
};
// Update OfficeStatus
// export const updateOfficeStatus = async (updatedOfficeStatus) => {
//   const updatedOfficeStatusData = {};
//   await axios.put(
//     `${api_base_url}/OfficeStatus/${updatedOfficeStatusData.OfficeStatusId}`,
//     updatedOfficeStatusData
//   );
// };/api/Configuration/OfficeStatus{id}`


export const updateOfficeStatus = async (updatedOfficeStatus) => {
  const { data } = await axios.put(
    `${api_base_url}/Configuration/OfficeStatus${updatedOfficeStatus.officeStatusId}`,updatedOfficeStatus
  );
  return data;
};

//Search officeStatus
export const searchOfficeStatus = async (searchInputsData) => {
  const data = {
    Status: searchInputsData.Status,
  };

  return await axios
    .post(`${api_base_url}/Configuration/SearchOfficeStatus`, data)
    .then((res) => res.data);
};

//Delete OfficeStatus by Id
// export const deleteOfficeStatus = async (OfficeStatusId) => {
//   await axios.delete(`${api_base_url}/Configuration/DeleteOfficeStatus`, {
//     data: OfficeStatusId,
//   });
// };




  //Delete OfficeStatus by Id
export const deleteOfficeStatus = async (OfficeStatusId) => {

 const {data} = await axios.delete(`${api_base_url}/Configuration/DeleteOfficeStatus`, {
    data: OfficeStatusId,
  });
  return data;
};